<template>
  <div class="p_post_content">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">岗位名称</div>
                    <el-input v-model="listQuery.keyword" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                    <el-button type="success" size="small" @click="searchHandle">搜索</el-button>
                </div>
            </div>
        </div>
        <!-- <div class="top-right">
            <el-button v-if="(isExport && this.tableData.length > 0)" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" :style="'margin-right:' +(!isExport && (tableData == [])?'0':'16px')">导出</el-button>
        </div> -->
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>系统</el-breadcrumb-item>
                <el-breadcrumb-item>岗位管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
      <div class="p_post_table" v-if="checkPermission(['postManage_page_list'],permissionLists)">
        <div class="p_btn_box" v-if="checkPermission(['postManage_add'],permissionLists)">
          <el-button type="success" size="small" plain @click="addHandle">创建</el-button>
        </div>
        <el-table class="post_list" v-loading="tableLoading" :highlight-current-row="true" border :max-height="tableHeight-100" :data="tableData" style="width:100%">
          <el-table-column align="center" label="序号" width="70px">
            <template slot-scope="{$index}">
              <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="岗位名称" min-width="130px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.StationName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="关联角色" min-width="130px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.Strroletypesname}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="岗位描述" min-width="200px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.StrRemark}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="使用人数" min-width="80px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span title="点击可查看人员详情" @click="memberHandle(row)" :class="Number(row.countuser)>0?'greenTxt':''">{{row.countuser}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" min-width="140px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{!isNullDate(row.CreatedTime)?row.CreatedTime.replace('T',' '):''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="160px" fixed="right">
            <template slot-scope="{row}">
              <el-button v-if="(row.IsDel != '2')&&(checkPermission(['postManage_edit'],permissionLists))" type="success" size="mini" plain @click="editHandle(row)">编辑</el-button>
              <el-button v-if="(row.IsDel != '1' && row.IsDel != '2')&&(checkPermission(['postManage_dlt'],permissionLists))" type="warning" size="mini" plain @click="dltHandle(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="changeBPage"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
    <!-- 员工信息弹框 -->
    <el-dialog title="员工信息" :visible.sync="memVisible" width="800px" class="post_dialog_content">
      <div class="m_box">
        <el-table :data="memberData" border style="width: 100%" v-loading="dialogLoading">
          <el-table-column align="center" prop="Strorganname" label="部门" min-width="100px" fit :show-overflow-tooltip="true" fixed>
          </el-table-column>
          <el-table-column align="center" label="员工姓名" min-width="120px" fixed fit :show-overflow-tooltip="true">
            <template scope="scope">
              <span>{{scope.row.Username}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="UserNumber" label="员工ID" min-width="100px"></el-table-column>
          <el-table-column align="center" prop="Stridcard" label="身份证号码" min-width="160px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="Strmobile" label="手机号码" min-width="110px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="Strstationname" label="岗位名称" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="strtopusername" label="上级主管" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column align="center" prop="DtEntryDate" label="入职时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.DtEntryDate && scope.row.DtEntryDate!='1900-01-01T00:00:00' ? scope.row.DtEntryDate.substring(0, 10): '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="DtQuitDate" label="离职时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.DtQuitDate && scope.row.DtQuitDate!='1900-01-01T00:00:00' ? scope.row.DtQuitDate.substring(0, 10): '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrWorkState" label="是否在职" min-width="100px"></el-table-column>
          <el-table-column align="center" prop="StrIspartner" label="是否合伙人" min-width="100px"></el-table-column>
        </el-table>
        <el-pagination
            @current-change="changeBPage1"
            :current-page.sync="dataPage.currpage"
            :page-size="dataPage.perpage"
            @size-change="handleSizeChange1"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalMem"
          ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
            @click="memVisible = false"
            size="small"
            >取消</el-button
          >
          <el-button @click="memVisible = false"
            type="primary"
            size="small"
            >关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
import checkPermission from '@/utils/permission' // 权限判断函数
export default {
  name: "postManage",
  data() {
    return {
      memVisible:false,
      dialogLoading:false,
      dataPage: {
        keyword: '',
        strWorkState: '在职',
        strstation:'',
        strorgancode:'',
        currpage: 1,
        perpage: 10
      },
      memberData:[],
        // 列表参数
        listQuery:{
          keyword:'', // 角色名称
          perpage: 10,
          currpage: 1
        },
        tableHeight:0,
        tableLoading:false,
        tableData:[],
        total:0,
        dltQuery:{
          Stationid:'' //角色标识
        },
        totalMem:0,
        // 按钮权限参数
        butQuery:{
          path:'/postManage',
          powerEnName:'system'
        },
        // 按钮权限
        permissionLists:[]
    }
  },
  created() {
    this.getButtonPower()
    this.calHeight()
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower(){
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if(that.checkPermission(['postManage_page_list'],that.permissionLists)){
              that.getList()
            }
          }else{
            this.permissionLists = []
          }
        }else{
          this.permissionLists = []
        }
      })
    },
    //判断是否为空(包含0)
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
    },
    // 编辑岗位
    editHandle(row){
      this.$router.push({
        path: "/addPosition",
        query: {
          isedit: 'true',
          Stationid: row.Stationid, // 岗位id
          StationName: row.StationName,// 岗位名称
          Strroletypes: row.Strroletypes,// 角色集合
          StrDataperm: row.StrDataperm,// 数据权限
          StrRemark: row.StrRemark
        }
      });
    },
    // 删除岗位
    dltHandle(row){
      this.dltQuery.Stationid = row.Stationid
      this.$confirm('是否确定删除此数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        xz.bdelauthStationList(this.dltQuery).then(res => {
          // console.log('删除', res)
          if (res.status == 'ok') {
            this.$message({ type: 'success', message: '删除成功' })
            this.getList()
          }else{
            this.$message({ type: 'error', message: res.msg })
          }
        })
      }).catch(() => {
        
      })
    },
    // 创建岗位
    addHandle(){
      this.$router.push({
        path: "/addPosition",
      });
    },
    // 查看人员
    memberHandle(item){
      this.dataPage.strstation = item.Stationid
      this.memVisible = true
      this.getauthUserInfoByorgancode()
    },
    //获取人员列表
    getauthUserInfoByorgancode() {
      this.dialogLoading = true;
      xz.getauthUserInfoByorgancode(this.dataPage).then(res => {
        if (res.status == 'ok') {
          this.memberData = res.msg;
          this.totalMem = res.totalcount;
        } else {
          this.memberData = [];
          this.totalMem = 0;
        }
        this.dialogLoading = false;
      })
    },
    //人员分页
    changeBPage1(val){
        this.dataPage.currpage = Number(val)
        this.getauthUserInfoByorgancode()
    },
    handleSizeChange1(val) {
      this.dataPage.currpage = 1
      this.dataPage.perpage = Number(val)
      this.getauthUserInfoByorgancode()
    },
    isNullDate(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01'
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.getList()
    },
    //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
      this.getList()
    },
    // 获取列表
    getList(){
      this.tableLoading = true
      xz.bgetStationauthList(this.listQuery).then(res => {
        // console.log('岗位', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.total = res.totalcount
        } else {
          this.tableData = []
          this.total = 0
        }
        this.tableLoading = false
      })
    }
  }
}
</script>
<style scoped>
.greenTxt{
  color:#000;
  font-weight: bold;
  cursor: pointer;
}
.p_btn_box{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.p_post_table{
    background-color: #fff;
}
</style>
<style>
.p_post_content .post_list.el-table .el-table__cell{
  padding: 3px 0;
}
</style>